const appMobile = (state = {
    drawerVisible: false,
    currentProjectId: null,
    dashboardSubteam: null
}, action) => {
    switch (action.type) {
        case 'TEAM_CHANGE':
        case 'RESET_STORE':
            return {
                drawerVisible: false,
                currentProjectId: null,
                dashboardSubteam: null
            };

        case 'SET_DRAWER_VISIBLE':
            return Object.assign({}, state, {
                drawerVisible: action.payload.drawerVisible
            });

        case 'SET_CURRENT_PROJECT':
            return Object.assign({}, state, {
                currentProjectId: action.payload.projectId
            });

        case 'SET_DASHBOARD_SUBTEAM':
            return Object.assign({}, state, {
                dashboardSubteam: action.payload.subteamId
            });

        default:
            return state;
    }
};

export default appMobile;
